/** Why an answer's score points the other way from its year-end price, from the card's own odds; null when they agree or the answer has no odds. */
import { pointsOppositeWays, scoreDelta, type RiskyChoices } from "./ownLimits";

export function scoreNoteOf(r: RiskyChoices[number]): string | null {
  if (!pointsOppositeWays(r, false)) return null;
  const delta = scoreDelta(r) ?? 0;
  const label = r.chance?.label;
  const because = label === undefined ? "" : ` (${label})`;
  return delta < 0 ? `Better this year; the years after cost more${because}.` : `Worse this year; the years after are better${because}.`;
}
